import { API_URL, API_VERSION } from '@constants';
import { useData } from '@hooks/useData';
import { paths } from '../../types/api';
import { ApiError, useApiConfig } from '@hooks/useApiConfig';

const ENDPOINT_URL = '/str-stores/all-stores-location';

const ENDPOINT_URL_WITH_VERSION = `${API_VERSION}${ENDPOINT_URL}` as const;
type url = typeof ENDPOINT_URL_WITH_VERSION;

export type GetStoresLocationSuccessResponse = paths[url]['get']['responses']['200']['content']['application/json'];

/**
 * Requests endpoint to get all stores' coordinates, grouped by city.
 * Then saves it in Data Context.
 */
export const useGetStoresLocations = () => {
    const { getHeaders, handleCommonErrors } = useApiConfig();
    const { setStoresLocations, setIsLoadingStoresLocations } = useData();

    const request = async () => {
        setIsLoadingStoresLocations(true);

        try {
            const response = await fetch(`${API_URL}${ENDPOINT_URL}`, {
                method: 'GET',
                headers: getHeaders(),
            });

            if (!response.ok) {
                const json = await response.json();
                const error = new Error(json.error || '') as ApiError;
                error.statusCode = response.status;
                throw error;
            }

            const data: GetStoresLocationSuccessResponse = await response.json();

            setStoresLocations(data);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err: any) {
            handleCommonErrors(err);
        } finally {
            setIsLoadingStoresLocations(false);
        }
    };

    return { request };
};
